import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export interface ManualEntryDialogResult
{
    success: boolean;
    accountNumber?: number;
    routingNumber?: number;
}

export interface ManualEntryDialogInput
{
    dialogTitle: string;
    dialogError?: string;
    accountNumber?: number;
    routingNumber?: number;
}

@Component({
    selector: 'lf-manual-account-entry',
    templateUrl: './manual-account-entry.component.html',
})
export class ManualAccountEntryComponent implements OnInit
{
    public form: FormGroup;

    constructor(
            private _dialogRef: MatDialogRef<ManualAccountEntryComponent>,
            private _builder: FormBuilder,
            @Inject(MAT_DIALOG_DATA) public data: ManualEntryDialogInput,
    ) {
    }

    ngOnInit() {
        this.form = this._builder.group({
            routingNumber: [
                this.data.routingNumber,
                [
                    Validators.required,
                    Validators.minLength(9),
                    Validators.maxLength(9),
                ],
            ],
            accountNumber: [
                this.data.accountNumber,
                [
                    Validators.required,
                    Validators.minLength(6),
                ],
            ],
        });
    }


    public closeDialog() {
        this._dialogRef.close(<ManualEntryDialogResult>{
            success: false,
        });
    }

    public handleBankInfo() {
        this._dialogRef.close(<ManualEntryDialogResult>{
            success: true,
            ...this.form.getRawValue(),
        });
    }
}
